import postPinUnapprovedView from './postPinUnapprovedComponent.html';
import './postPinUnapprovedComponent.css';

export function postPinUnapprovedComponent() {
	return {
		bindings: {
			post: '=',
		},
		controllerAs: 'vm',
		controller: postPinUnapprovedComponentCtrl,
		template: postPinUnapprovedView,
	};
}

export class postPinUnapprovedComponentCtrl {
	constructor(Api, Identity) {
		'ngInject';
		this.Api = Api;
		this.isApprover = Identity.isApprover();
	}

	approve() {
		this.post.approval_status = 'approved';
		this.Api.patch(`/posts/${this.post.id}`, {
			approval_status: 'approved',
		});
	}
}
